import { Breakpoint, BreakpointState } from '../services/media-query.service';

export type TableView = 'card' | 'table' | 'table_narrow';

export class TableViewHelper {

  static fromBreakpoint(breakpoint: BreakpointState): TableView {
    if (breakpoint.isBreakpointMatch(Breakpoint.SM)) {
      return 'card';
    }
    if (breakpoint.isBreakpointMatch(Breakpoint.MD)) {
      return 'table_narrow';
    }
    return 'table';
  }
}
